import React from 'react';

import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

let id = 0;
function createData(name, date, progress) {
  id += 1;
  return { id, name, date, progress };
}

const data = [
  createData('Company A', 'Feb 12', '€150M'),
  createData('Company B', 'Oct 19', '€65M'),
  createData('Company C', 'Dez 4', '€250M')
];

const TransactionsTable = () => {
  return (
    <Card>
      <CardHeader
        action={
          <IconButton
            id={'menu-button'}
            // onClick={handleClick}
          >
            <MoreVertIcon />
          </IconButton>
        }
        subheader={'Recent comparable transactions'}
      />
      <CardContent>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ISSUER (TARGET)</TableCell>
              <TableCell>DATE</TableCell>
              <TableCell>SIZE</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map(n => (
              <TableRow key={n.id}>
                <TableCell component="th" scope="row">
                  {n.name}
                </TableCell>
                <TableCell>{n.date}</TableCell>
                <TableCell>{n.progress}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default TransactionsTable;
